export let ANGLE_BRACKET_LEFT = '\u2329'; // <
export let ANGLE_BRACKET_RIGHT = '\u232A'; // >
export function leftBracket(isClosed) {
    return isClosed ? ANGLE_BRACKET_LEFT : '(';
}
export function rightBracket(isClosed) {
    return isClosed ? ANGLE_BRACKET_RIGHT : ')';
}
//# sourceMappingURL=formatting.js.map